<template>
    <Chart type="pie" :chartdata="data" :options="options"></Chart>
</template>
<script>
import db from '@/components/firebase.init'
import Chart from '@/components/charts/Charts'
export default {
    
    data(){
        
        return{
          company_id: this.$route.params.companyId,
            options: {
               
         tooltips: {
    callbacks: {
      label: function(tooltipItem, data) {
        var dataset = data.datasets[tooltipItem.datasetIndex];
        var meta = dataset._meta[Object.keys(dataset._meta)[0]];
        var total = meta.total;
        var currentValue = dataset.data[tooltipItem.index];
        var percentage = parseFloat((currentValue/total*100).toFixed(1));
        return currentValue + ' (' + percentage + '%)';
      },
      title: function(tooltipItem, data) {
        return data.labels[tooltipItem[0].index];
      }
    }
  },
                scales: {
                    yAxes: [{
                        display: true,
                            gridLines: {
                                display: true,
                                color: 'rgb(255, 255, 255, .3)',
                                borderDash: [1],
                                lineWidth: '1',
                                zeroLineWidth: '1',
                                zeroLineColor: 'rgb(255, 255, 255, .3)',
                                },
                        ticks: {
                            beginAtZero: true,
                            fontColor: 'white',
                        }
            
                    }],
                    xAxes: [{
                        display: true,
                            gridLines: {
                                display: true,
                                color: 'rgb(255, 255, 255, .3)',
                                borderDash: [1],
                                lineWidth: '1',
                                zeroLineWidth: '1',
                                zeroLineColor: 'rgb(255, 255, 255, .3)',
                                },
                        ticks: {
                            beginAtZero: true,
                            fontColor: 'white',
                        }
            
                    }],
                },
                animation: {
                easing: 'easeOutBounce',
                numSteps: '100',
                },
                hover: {
                    animationDuration: '1',
                },
                legend: {
                    display: true,
                    labels: {
                    fontColor: 'white',
                    position: 'bottom',
                    }
                },
            },
            data:{
                labels: [
                    
                ],
                datasets: []
            },
            chartArray: [],
            ids:[],
            
        }
            
    },
    methods:{
        getChartData(){
            const companyId = this.company_id;
             var docRef = db.collection("companyAnalytics").doc(companyId).collection("widgetTwo").doc("listing");
            docRef.get()
            .then((doc) => {
                const data = doc.data();
                if(doc.exists){
   if(data.HIGH != null){
                    this.chartArray[0] = data.HIGH;
                }
                   if(data.MEDIUM != null){
                    this.chartArray[1] = data.MEDIUM;
                }
             
                   if(data.LOW != null){
                    this.chartArray[2] = data.LOW;
                }

                }
             
             
            
                this.loadChart();
            })
            .catch(err => {
                console.log('Error getting documents', err);
            });
        },
        loadChart(){
            this.data = {
                labels:['High','Medium','Low'],
                datasets: [{
                    data: this.chartArray,
                    legend : [
                        'white',
                    ],
                    backgroundColor: [
                        '#bb2528', //high
                        '#f8b229', //medium
                        '#13cc43', //low
                        ],
                    borderColor: 'rgb(255, 255, 255,1)',
                    borderWidth: '2',
                }]
            }
                console.log(this.chartArray);
            }
        },
    components: {
        Chart
    },
    beforeMount(){
     this.getChartData()
    },
    
}
</script>

